import { supabase } from "./supabaseClient";

export async function getRedemptionCode(userId: number) {
  const { data } = await supabase
    .from("redeem_codes")
    .select("id, url")
    .is("user_id", null)
    .order("id", { ascending: true })
    .limit(1);

  if (!data || data.length === 0) return { error: "Códigos esgotados." };

  const code = data[0];

  const { error: updateError } = await supabase
    .from("redeem_codes")
    .update({
      user_id: userId,
      used_at: new Date().toISOString(),
      platform: "AUTHENTICATOR",
    })
    .eq("id", code.id)
    .is("user_id", null);

  if (updateError) return { error: "Erro ao resgatar código." };

  return { url: code.url };
}
